// Kjøp, hovedbok og bilagsinnboks (no).
window.PlummeI18n.register('no', {
  // ------------------------------------------------------- Kjøp (purchases)
  'buy.remove': 'Fjern',
  'buy.openPreview': 'Åpne forhåndsvisning',
  'buy.noPreview': 'Ingen forhåndsvisning',
  'buy.savedInBackend': 'Bilaget er lagret.',
  'buy.open': 'Åpne',
  'buy.addMoreDocs': 'Legg til flere bilag',
  'buy.addMoreDocsHelp': 'Legg ved flere kvitteringer eller sider på samme kjøp. Alle vedlagte bilag listes opp her.',
  'buy.uploadDoc': 'Last opp bilag',
  'buy.uploadDocHelp': 'Legg ved kvitteringen eller fakturaen for kjøpet. Du kan dra inn en fil, velge fra maskinen, eller hente et bilag fra innboksen.',
  'buy.dropOrPick': 'Slipp eller velg bilag',
  'buy.storedIn': 'PDF eller bilde lagres i Firebase/innboksen.',
  'buy.fromInbox': 'Hent fra innboks',
  'buy.attachments': 'Vedlegg',
  'buy.pickFiles': 'Velg filer',
  'buy.dropAttachments': 'Slipp vedlegg her',
  'buy.attachmentsNote': 'Vedlegg lastes til backend når føringen lagres.',
  'buy.supplierSearch': 'Søk eller legg til leverandør...',
  'buy.supplierSearchShort': 'Søk eller legg til leverandør',
  'buy.supplierClose': 'Lukk leverandørvalg',
  'buy.supplierNone': 'Ingen leverandører funnet.',
  'buy.supplierNew': 'Ny leverandør',
  'buy.name': 'Navn',
  'buy.org': 'Org.nr.',
  'buy.email': 'E-post',
  'buy.phone': 'Telefon',
  'buy.accountClose': 'Lukk kontovalg',
  'buy.searchShort': 'Søk ...',
  'buy.noAccountMatch': 'Ingen konto matcher søket.',
  'buy.fromInboxRead': 'Hentet fra innboksen - SuperPlumma har lest av det vi kunne.',
  'buy.docHelp': 'Bilaget er kvitteringen eller fakturaen som dokumenterer kjøpet. Dra inn et bilde eller en PDF - eller trykk for å velge fil. SuperPlumma leser av dato, beløp, leverandør og MVA, og foreslår hvordan kjøpet skal bokføres.',
  'buy.dropReceipt': 'Slipp kvitteringen her',
  'buy.dropReceiptHelp': 'Hent bilaget fra filene dine, eller velg «Hent fra innboks» for å bruke et bilag som allerede er kommet inn på e-post. SuperPlumma leser av innholdet automatisk.',
  'buy.upload': 'Last opp',
  'buy.type': 'Type kjøp',
  'buy.typeHelp': 'Velg hvordan kjøpet skal registreres. «Betalt kjøp» er et kjøp som allerede er betalt. «Leverandørfaktura» brukes når fakturaen skal betales senere eller er delbetalt (blir til leverandørgjeld). «Utkast» viser påbegynte kjøp du ikke har bokført ennå.',
  'buy.description': 'Beskrivelse',
  'buy.descriptionPh': 'F.eks. abonnement eller reise',
  'buy.toggleVat': 'Bytt mellom eks. og inkl. MVA',
  'buy.amountExInc': 'Beløp eks./inkl. MVA',
  'buy.amountExIncHelp': 'Trykk for å bytte om du skriver inn beløpet uten MVA (netto) eller med MVA (brutto). Plumme regner automatisk om mellom de to. «Eks. MVA» er selve kostnaden, «inkl. MVA» er totalbeløpet du betalte.',
  'buy.vatRate': 'MVA-sats',
  'buy.vatRateHelp': 'Merverdiavgift-satsen på kjøpet. 25 % er normalsatsen, 15 % gjelder næringsmidler (mat), 12 % gjelder bl.a. persontransport og overnatting, og 0 % brukes for avgiftsfrie kjøp. MVA-en på et kjøp er inngående MVA, som du får fradrag for.',
  'buy.pickCategory': 'Konto/kategori',
  'buy.category': 'Kategori',
  'buy.categoryHelp': 'Hva slags kostnad dette er. Kategorien bestemmer hvilken konto kjøpet bokføres på i regnskapet, slik at det havner riktig i resultatregnskapet og skattemeldingen.',
  'buy.supplier': 'Leverandør',
  'buy.accountFromHistory': 'Kostnadskonto foreslått fra tidligere kjøp hos leverandøren. Du kan endre den på kjøpslinjen.',
  'buy.date': 'Kjøpsdato',
  'buy.invoiceNumber': 'Fakturanummer',
  'buy.invoiceNumberPh': 'F.eks. 100245',
  'buy.dueDate': 'Forfallsdato',
  'buy.lines': 'Linjer',
  'buy.linesHelp': 'Hver linje er én kostnad på bilaget, med eget beløp, MVA-sats og kategori. Har kvitteringen flere ulike varer eller MVA-satser, lager du én linje per type. Du kan dra linjene for å endre rekkefølge.',
  'buy.addLine': 'Legg til linje',
  'buy.payment': 'Betaling',
  'buy.paymentHelp': 'For leverandørfaktura velger du om fakturaen er betalt. Ubetalte fakturaer lagres som åpen leverandørgjeld, slik at betalingen kan registreres senere.',
  'buy.immediatePaymentHelp': 'Et vanlig kjøp er allerede betalt. Velg hvilken konto betalingen gikk fra og datoen den ble betalt.',
  'buy.paid': 'Betalt',
  'buy.unpaid': 'Ikke betalt',
  'buy.paidFrom': 'Betalt fra',
  'buy.choosePaymentSource': 'Velg betalingskilde',
  'buy.paidDate': 'Betalt dato',
  'buy.paidDateHelp': 'Datoen kjøpet ble betalt. Kjøpsdatoen styrer regnskaps- og MVA-perioden for selve kjøpet.',
  'buy.dateLabel': 'Dato',
  'buy.addPartPayment': 'Legg til delbetaling',
  'buy.addPartPaymentHelp': 'Registrer enda en innbetaling. Summen av delbetalingene trekkes fra totalen - det som står igjen vises som «gjenstår».',
  'buy.remaining': 'Gjenstår',
  'buy.remainingHelp': 'Differansen mellom totalbeløpet og det du har registrert som delbetalinger. Er den 0, er kjøpet fullt oppgjort.',
  'buy.preview': 'Forhåndsvisning',
  'buy.previewHelp': 'Forhåndsvisning av bilaget du har lastet opp. Har du ikke lastet opp noe bilag, kan du gjøre det her.',
  'buy.dropReceiptLong': 'Slipp kvitteringen her - dra inn et bilde eller PDF, eller trykk for å velge fil.',
  'buy.summaryHelp': 'Oppsummeringen viser netto, MVA og totalsummen du betaler.',
  'buy.saveDraft': 'Lagre utkast',
  'buy.saveDraftHelp': 'Lagrer kjøpet som et utkast uten å bokføre det. Bilag og betalinger blir ikke markert som bokført før du fullfører kjøpet.',
  'buy.title': 'Betalt kjøp',
  'buy.subtitle': 'Registrer et kjøp - last opp bilaget, så foreslår vi resten.',
  'buy.drafts': 'Utkast',
  'buy.draftsSub': 'Påbegynte kjøp og eiendeler du ikke har bokført ennå',
  'buy.draftsSearchPh': 'Leverandør, beskrivelse, fakturanr. eller beløp',
  'buy.showMore': 'Vis flere',
  'buy.noDrafts': 'Ingen utkast',
  'buy.invoiceNoShort': 'Fakturanr.',
  'buy.delete': 'Slett',
  'buy.deleteDraftTitle': 'Slette utkast?',
  'buy.deleteDraftConfirm': 'Ja, slett utkast',
  'buy.deleteDraftBody': 'Er du sikker på at du vil slette utkastet for',
  'buy.resetTitle': 'Nullstill skjemaet og start på nytt',
  'buy.reset': 'Nullstill',
  'buy.howRegister': 'Hvordan vil du registrere kjøpet?',
  'buy.howRegisterSub': 'Last gjerne opp bilaget først - så foreslår vi resten for deg.',
  'buy.stepByStep': 'Steg for steg',
  'buy.stepByStepHelp': 'Fører deg gjennom kjøpet én del om gangen - først bilag, så dato, linjer og betaling. Fin når du vil ta det rolig.',
  'buy.stepByStepShort': 'Bilag først, deretter dato, linjer og betaling.',
  'buy.onePage': 'Alt på én side',
  'buy.onePageHelp': 'Viser hele kjøpsskjemaet samlet på én side. Fin når du er vant til å registrere kjøp og vil ha alt foran deg.',
  'buy.onePageShort': 'Hele kjøpsskjemaet samlet.',
  'buy.toSteps': 'Bytt til steg-for-steg',
  'buy.toOnePage': 'Bytt til alt på en side',
  'buy.back': 'Tilbake',
  'buy.next': 'Neste',
  'buy.backToVouchers': 'Tilbake til transaksjoner',
  'buy.salesType': 'Salgstype',
  'buy.paidTo': 'Betalt til',
  'buy.payOperating': 'Driftskonto',
  'buy.payCash': 'Kontant',
  'buy.payPrivate': 'Privat',
  'buy.privateDeposit': 'Privat innskudd',
  'buy.whatSold': 'Hva solgte du?',
  'buy.amountExVat': 'Beløp ekskl. MVA',
  'buy.amountIncVat': 'Beløp inkl. MVA',
  'buy.vatLabel': 'MVA/moms',
  'buy.otherSale': 'Annet salg',
  'buy.invoiceOrQuote': 'Faktura / tilbud',
  'buy.switchMode': 'Bytt modus',
  'buy.moreOptions': 'Flere valg',
  'buy.postAs': 'Bokfør som',
  // -------------------------------------------------------- Paid-purchase page
  'buy.backendUploadNotReady': 'Backend-opplasting er ikke klar.',
  'buy.multipleUploadedShowFirst': 'Flere bilag ble lastet opp. Viser det første her.',
  'buy.uploadFailed': 'Kunne ikke laste opp bilaget.',
  'buy.dropReceiptTitle': 'Slipp kvitteringen her',
  'buy.dropReceiptSubtitle': '...så hjelper vi deg å plassere den riktig. Dra inn et bilde eller PDF, eller trykk for å velge fil.',
  'buy.attachedCount': '{count} bilag koblet',
  'buy.uploading': 'Laster opp...',
  'buy.chooseFile': 'Velg fil',
  'buy.dropToUpload': 'Slipp bilaget for å laste opp',
  'buy.accountFallbackOperating': 'Driftskonto · 1920',
  'buy.accountFallbackCash': 'Kontant',
  'buy.accountFallbackPrivate': 'Privat utlegg',
  'buy.accountFallbackCash1900': 'Kontant - 1900',
  'buy.accountFallbackPrivate2060': 'Privat - 2060',
  'buy.addSupplierQuery': 'Legg til «{query}»',
  'buy.chartNotConnected': 'Kontoplanen er ikke koblet til lagring.',
  'buy.accountAdded': 'Kontoen er lagt til.',
  'buy.accountSaveFailed': 'Kunne ikke lagre kontoen.',
  'buy.chooseAccount': 'Velg konto',
  'buy.forQuery': 'for «{query}»',
  'buy.newCustomAccountTitle': 'Ny egendefinert konto',
  'buy.saving': 'Lagrer...',
  'buy.saveAccount': 'Lagre konto',
  'buy.accountNamePlaceholder': 'F.eks. Programvare utvikling',
  'buy.accountHelperText': 'Kontoen blir tilgjengelig i kontosøket og mappes til standardkontoen for rapportering og årsavslutning.',
  'buy.inventoryProduct': 'Lagervare',
  'buy.notTracked': 'Ikke lagerført',
  'buy.quantityInStock': 'Antall inn på lager',
  'buy.inStockCount': '{n} på lager',
  'buy.inventoryLineToggle': 'Skal lagerføres',
  'buy.inventoryLineToggleHelp': 'Slå på når kjøpet skal øke beholdningen til en registrert lagervare.',
  'buy.inventorySearchPlaceholder': 'Velg lagervare',
  'buy.inventorySearch': 'Søk etter navn, varenummer, SKU eller EAN',
  'buy.inventorySearchEmpty': 'Ingen lagerførte varer passer søket.',
  'buy.inventoryOpenProducts': 'Åpne produkter',
  'buy.inventoryUnitsInStock': 'på lager',
  'inventoryPurchase.settingsTitle': 'Lagerføring på kjøp',
  'inventoryPurchase.settingsHelp': 'Vis et valgfritt lagerfelt på kjøpslinjer, slik at et kjøp kan øke beholdningen til en registrert lagervare.',
  'inventoryPurchase.offHelp': 'Lagerfeltet er skjult på nye kjøp. Produkter og tidligere lagerbevegelser beholdes.',
  'inventoryPurchase.migratedTitle': 'Lagerføring på kjøp er slått på',
  'inventoryPurchase.migratedText': 'Foretaket har allerede produkter med automatisk lagerføring. Derfor er lagerkoblingen på kjøpslinjer aktivert, slik at eksisterende arbeidsflyt fortsetter.',
  'inventoryPurchase.acknowledge': 'Jeg forstår',
  'inventoryPurchase.acknowledgeError': 'Kunne ikke lagre bekreftelsen.',
  'inventoryPurchase.openSettings': 'Åpne innstillinger',
  'inventoryPurchase.disableTitle': 'Slå av lagerføring på kjøp?',
  'inventoryPurchase.disableConfirm': 'Slå av',
  'inventoryPurchase.disableWarning': 'Lagerfeltet skjules på nye kjøp. Kjøp kan da ikke kobles til lagerførte produkter, og beholdningen kan bli feil hvis den ikke kontrolleres og justeres manuelt.',
  'inventoryPurchase.disableHistory': 'Eksisterende produkter og historiske lagerbevegelser slettes ikke. Tell lageret og registrer nødvendige justeringer manuelt.',
  'inventoryPurchase.enabledLabel': 'Lagerføring på kjøp',
  'inventoryPurchase.disabledLabel': 'Lagerføring på kjøp',
  'buy.noDescription': 'Uten beskrivelse',
  'buy.attachmentFallback': 'Bilag',
  'buy.lockVatTitle': 'MVA-terminen er levert',
  'buy.lockYearTitle': 'Regnskapsåret er avsluttet',
  'buy.lockBankTitle': 'Bankperioden er avstemt',
  'buy.lockVatTarget': 'MVA-terminen',
  'buy.lockYearTarget': 'årsavslutningen',
  'buy.lockBankTarget': 'bankavstemmingen',
  'buy.lockWarningText': '{title}. Du kan fortsatt endre beskrivelse og kostnadskonto/kategori på kjøpet, men kjøpsdato, beløp, MVA-kode og betalingsfelter er låst. Åpne eller korriger {target} hvis du må endre disse feltene.',
  'buy.lockVatWarningText': '{title}. Kjøpsdato, beløp og MVA-kode er låst, men beskrivelse, kostnadskonto/kategori og betalingskonto kan fortsatt korrigeres. Åpne eller korriger {target} hvis MVA-grunnlaget må endres.',
  'buy.backendSaveNotReady': 'Backend-lagring er ikke klar.',
  'buy.needAtLeastOneLine': 'Legg til minst en kjøpslinje.',
  'buy.needDescriptionAllLines': 'Legg inn beskrivelse på alle linjer før du bokfører.',
  'buy.needContentForDraft': 'Legg til en linje, leverandør eller et bilag før du lagrer utkast.',
  'buy.needSupplierForInvoice': 'Velg leverandør eller fyll inn leverandørnavn før du lagrer delbetaling/leverandørfaktura.',
  'buy.draftSaved': 'Utkast lagret.',
  'buy.attachmentUpdated': 'Bilaget er oppdatert.',
  'buy.invoiceRegisteredOpen': 'Faktura registrert som åpen leverandørfaktura.',
  'buy.purchaseBooked': 'Kjøp bokført! Bilaget ligger nå under Transaksjoner.',
  'buy.purchaseSaveFailed': 'Kunne ikke lagre kjøpet.',
  'buy.docsFetchedFromInbox': '{count} bilag hentet fra innboksen',
  'buy.fullPayment': 'Full betaling',
  'buy.partPayment': 'Delbetaling',
  'buy.partPaymentWarning': 'Delbetaling registreres som leverandørfaktura. Resten føres som leverandørgjeld på 2400 til den betales.',
  'buy.partPaymentLabel': 'Delbetaling {n}',
  'buy.remainingSuffix': '· gjenstår',
  'buy.unpaidWillBeInvoice': 'Uten registrert betaling lagres dette som en åpen leverandørfaktura. Du kan registrere betaling senere.',
  'buy.forgotReceiptTitle': 'Har du glemt bilaget?',
  'buy.registerInvoice': 'Registrer faktura',
  'buy.bookPurchase': 'Bokfør kjøp',
  'buy.registerInvoiceHelp': 'Lagrer fakturaen som åpen leverandørgjeld. Den dukker opp under leverandøren, og du registrerer betaling når den er betalt.',
  'buy.bookPurchaseHelp': 'Lagrer kjøpet i regnskapet. Bilaget havner under «Transaksjoner», og beløpene føres på riktige kontoer.',
  'buy.typeBadgeInvoice': 'Faktura',
  'buy.typeBadgeAsset': 'Eiendel',
  'buy.draftDeleteNotConnected': 'Sletting av utkast er ikke koblet til backend.',
  'buy.draftDeleted': 'Utkast slettet.',
  'buy.draftDeleteFailed': 'Kunne ikke slette utkast.',
  'buy.pageHelpDrafts': 'Her registrerer du alt selskapet kjøper. Velg «Utkast» i nedtrekksmenyen for å se påbegynte kjøp du ikke har bokført ennå.',
  'buy.draftsPageHelp': 'Kjøp du har begynt på men ikke fullført lagres her. Åpne et utkast for å fortsette, eller slett det du ikke trenger.',
  'buy.viewOptionsLabel': 'Visningsvalg',
  'buy.assetsLabel': 'Eiendeler',
  'buy.noDraftsMatchSearch': 'Ingen utkast matcher søket.',
  'buy.draftsEmptyHint': 'Påbegynte kjøp du lagrer som utkast vises her.',
  'buy.colSupplier': 'Leverandør',
  'buy.noSupplier': 'Uten leverandør',
  'buy.colType': 'Type',
  'buy.colInvoiceNo': 'Fakturanr.',
  'buy.colDate': 'Dato',
  'buy.colAmount': 'Beløp',
  'buy.thisPurchaseFallback': 'dette kjøpet',
  'buy.cannotBeUndone': '? Dette kan ikke angres.',
  'buy.formReset': 'Skjemaet er nullstilt',
  'buy.editPurchaseSubtitle': 'Oppdater bilaget og lagre endringene i backend.',
  'buy.newPurchasePageHelp': 'Her registrerer du alt selskapet kjøper - varer, utstyr, abonnement, reiser. Last opp bilaget, så leser SuperPlumma av detaljene og bokfører kostnaden på riktig konto med riktig MVA.',
  'buy.defaultLineDescription': 'Kjøp',
  'buy.customerFallback': 'Kunde',
  'buy.supplierAndDateTitle': 'Leverandør og dato',
  'buy.supplierAndDateInvoiceHelp': 'Hvem du kjøpte fra og når. Fakturadato er datoen på fakturaen, og forfallsdato er når den må betales. Fakturanummeret er leverandørens eget nummer på fakturaen.',
  'buy.supplierAndDatePurchaseHelp': 'Kjøpsdatoen avgjør hvilken regnskaps- og MVA-periode kjøpet havner i. Bruk datoen på kvitteringen.',
  // ---------------------------------------- Kjøpskategorier / kontoplan
  'buy.katFixedAssets': 'Driftsmidler / utstyr',
  'buy.katRent': 'Husleie',
  'buy.katPhoneInternet': 'Telefon og internett',
  'buy.katSoftware': 'Programvare / abonnement',
  'buy.katTravel': 'Reise og diett',
  'buy.katRepresentation': 'Representasjon',
  'buy.acct4000': 'Råvarer og halvfabrikata',
  'buy.acct4300': 'Innkjøp av varer for videresalg',
  'buy.acct4500': 'Fremmedytelser og underentreprenører',
  'buy.acct5000': 'Lønn til ansatte',
  'buy.acct5400': 'Arbeidsgiveravgift',
  'buy.acct5900': 'Gaver til ansatte',
  'buy.acct6000': 'Avskrivninger',
  'buy.acct6100': 'Frakt og transportkostnad',
  'buy.acct6200': 'Energi, strøm og varme',
  'buy.acct6300': 'Leie lokaler',
  'buy.acct6320': 'Renovasjon, vann, avløp mv.',
  'buy.acct6340': 'Lys, varme',
  'buy.acct6360': 'Renhold',
  'buy.acct6400': 'Leie maskiner',
  'buy.acct6500': 'Verktøy og inventar',
  'buy.acct6540': 'Inventar og utstyr',
  'buy.acct6550': 'Driftsmaterialer',
  'buy.acct6560': 'Rekvisita',
  'buy.acct6600': 'Reparasjon og vedlikehold bygninger',
  'buy.acct6690': 'Reparasjon og vedlikehold annet',
  'buy.acct6700': 'Revisjon og regnskap',
  'buy.acct6720': 'Juridisk bistand',
  'buy.acct6790': 'Annen fremmed tjeneste',
  'buy.acct6800': 'Kontorrekvisita',
  'buy.acct6810': 'Data/EDB-kostnad',
  'buy.acct6820': 'Trykksaker',
  'buy.acct6900': 'Telefon',
  'buy.acct6940': 'Porto',
  'buy.acct7000': 'Drivstoff transportmidler',
  'buy.acct7020': 'Vedlikehold bil',
  'buy.acct7040': 'Forsikring og avgifter transportmidler',
  'buy.acct7100': 'Bilgodtgjørelse',
  'buy.acct7140': 'Reisekostnad ikke oppgavepliktig',
  'buy.acct7150': 'Diettkostnad',
  'buy.acct7160': 'Reisekostnad oppgavepliktig',
  'buy.acct7300': 'Salgskostnad',
  'buy.acct7320': 'Reklame og annonser',
  'buy.acct7350': 'Representasjon fradragsberettiget',
  'buy.acct7360': 'Representasjon ikke fradragsberettiget',
  'buy.acct7400': 'Kontingent',
  'buy.acct7500': 'Forsikringspremie',
  'buy.acct7600': 'Lisens, patent og royalty',
  'buy.acct7700': 'Annen driftskostnad',
  'buy.acct7770': 'Bank- og kortgebyrer',
  'buy.acct7790': 'Annen kostnad',
  'buy.acct8050': 'Renteinntekt',
  'buy.acct8150': 'Rentekostnad',
  'buy.acct8300': 'Betalbar skatt',
  'buy.fallbackCostName': 'Kostnad',
  'buy.fallbackAccountName': 'Konto',
  'buy.grp40': 'Varekostnad',
  'buy.grp43': 'Varer for videresalg',
  'buy.grp45': 'Innkjøp av tjenester',
  'buy.grp50': 'Lønn',
  'buy.grp54': 'Arbeidsgiveravgift',
  'buy.grp59': 'Personalkostnader',
  'buy.grp60': 'Avskrivninger',
  'buy.grp61': 'Frakt og transport',
  'buy.grp62': 'Energi og varme',
  'buy.grp63': 'Lokaler',
  'buy.grp64': 'Leie maskiner og utstyr',
  'buy.grp65': 'Verktøy og inventar',
  'buy.grp66': 'Reparasjon og vedlikehold',
  'buy.grp67': 'Fremmede tjenester',
  'buy.grp68': 'Kontorkostnader',
  'buy.grp69': 'Telefon, porto mv.',
  'buy.grp70': 'Transportmidler',
  'buy.grp71': 'Reise og diett',
  'buy.grp73': 'Salg og representasjon',
  'buy.grp74': 'Kontingenter',
  'buy.grp75': 'Forsikring',
  'buy.grp76': 'Lisens og royalty',
  'buy.grp77': 'Andre driftskostnader',
  'buy.grp15': 'Kortsiktige fordringer',
  'buy.grp24': 'Leverandørgjeld',
  'buy.groupAssets': 'Eiendeler',
  'buy.groupEquityAndLiabilities': 'Egenkapital og gjeld',
  'buy.groupIncome': 'Inntekter',
  'buy.groupCostOfGoods': 'Varekostnad',
  'buy.groupPayrollAndPersonnel': 'Lønn og personalkostnader',
  'buy.groupOtherOperating': 'Andre driftskostnader',
  'buy.groupFinanceAndTax': 'Finans og skatt',
  'buy.groupAccountsFallback': 'Kontoer',
  // --------------------------------------------------------- Saldobalanse
  'rep.trial.onlyMovement': 'Vis kun konti med bevegelse',
  'rep.trial.showInactive': 'Vis også inaktive konti',
  'rep.trial.payrollLiability': 'Skyldig lønn',
  'rep.trial.holidayPayLiability': 'Skyldige feriepenger',
  'rep.trial.oneEmployee': '{n} ansatt',
  'rep.trial.employeeCount': '{n} ansatte',
  'rep.trial.otherPayrollLiability': 'Alle posteringer på 2930',
  'rep.trial.allAccountEntries': 'Alle posteringer på {account}',
  'rep.trial.payrollRun': 'Lønnskjøring {period}',
  'rep.trial.term': '{term}. termin {year}',
  'rep.trial.accrualYear': 'Opptjeningsår {year}',
  // --------------------------------------------------- Alle bilag / hovedbok

  // ------------------------------------------------------- Innboks / bilagsvisning
  'vehiclePolicy.dialogTitle': 'Kjøretøy og kjøretøykostnader',
  'vehiclePolicy.intro': 'Velg hvordan Plumme skal behandle drivstoff, verksted og andre tydelige kjøretøykostnader. Dette er en arbeidsinnstilling for bilagsforslag og registrerer ikke et kjøretøy som eiendel.',
  'vehiclePolicy.optionVat': 'Kjøretøy med MVA-fradrag',
  'vehiclePolicy.optionVatSub': 'Foretaket eier eller leier kjøretøyet, kjøretøytypen gir fradragsrett, og kostnaden gjelder registrert avgiftspliktig virksomhet.',
  'vehiclePolicy.optionNoVat': 'Kjøretøy uten MVA-fradrag',
  'vehiclePolicy.optionNoVatSub': 'Foreslå kjøretøykostnaden uten fradrag for inngående MVA.',
  'vehiclePolicy.optionManual': 'Kontroller hvert bilag manuelt',
  'vehiclePolicy.optionManualSub': 'Plumme foreslår konto, men lar MVA-fradraget stå til kontroll.',
  'vehiclePolicy.validFrom': 'Gjelder fra',
  'vehiclePolicy.noEndDateWarning': 'Uten sluttdato gjelder valget til du endrer det. Et nytt valg avslutter automatisk det forrige fra endringsdatoen.',
  'vehiclePolicy.responsibility': 'Jeg bekrefter at opplysningen er riktig, og forstår at jeg selv må oppdatere den dersom kjøretøyet selges, leasingavtalen avsluttes, kjøretøytypen eller bruken endres.',
  'vehiclePolicy.receiptTitle': 'Avklar kjøretøy én gang',
  'vehiclePolicy.receiptText': 'Da kan senere drivstoff- og verkstedbilag få riktig MVA-forslag automatisk.',
  'vehiclePolicy.changeFromReceiptTitle': 'Endre kjøretøyregelen?',
  'vehiclePolicy.changeFromReceiptText': 'Du har satt dette kjøretøybilaget til 0 % MVA-fradrag. Skal det bare gjelde dette bilaget, eller skal Plumme behandle kjøretøykostnader uten MVA-fradrag fremover fordi kjøretøyet er solgt, leasing er avsluttet eller fradragsretten ikke lenger gjelder?',
  'vehiclePolicy.changeFromReceiptDate': 'Ny regel vil gjelde fra {date}.',
  'vehiclePolicy.receiptOnly': 'Bare dette bilaget',
  'vehiclePolicy.updateToNoVat': 'Bruk 0 % fremover',
  'vehiclePolicy.settingsTitle': 'Kjøretøy og kjøretøykostnader',
  'vehiclePolicy.settingsText': 'Styrer automatiske forslag på drivstoff, verksted og andre tydelige kjøretøykostnader. Innstillingen bokfører ikke, og oppretter ingen eiendel eller leasingavtale.',
  'vehiclePolicy.choose': 'Velg innstilling',
  'vehiclePolicy.change': 'Endre innstilling',
  'vehiclePolicy.save': 'Lagre og bruk',
  'vehiclePolicy.saved': 'Kjøretøyinnstillingen er lagret.',
  'vehiclePolicy.saveError': 'Kjøretøyinnstillingen kunne ikke lagres.',
  'vehiclePolicy.chooseError': 'Velg hvordan kjøretøybilag skal behandles.',
  'vehiclePolicy.confirmError': 'Bekreft at foretaket selv holder opplysningen oppdatert.',
  'vehiclePolicy.notConfigured': 'Ikke konfigurert – kjøretøybilag må kontrolleres',
  'vehiclePolicy.activeFrom': 'Gjelder fra',
  'vehiclePolicy.noEndDate': 'ingen sluttdato',
  'vehiclePolicy.mode.vat_deductible': 'Kjøretøy med MVA-fradrag',
  'vehiclePolicy.mode.no_vat_deduction': 'Kjøretøy uten MVA-fradrag',
  'vehiclePolicy.mode.manual_review': 'Manuell kontroll av hvert bilag',
  'buy.vatDeduction': 'Fradrag for inngående MVA',
  'buy.vatDeductionFull': '100 %',
  'buy.vatDeductionNone': '0 %',
  'buy.vatDeductionPartial': 'Delvis',
  'buy.vatDeductionPercent': 'Fradragsprosent',
  'buy.fixedAssetLine': 'Registrer linjen som eiendel',
  'buy.fixedAssetLineHelp': 'Linjen legges til i eiendelsregisteret i stedet for å behandles bare som kostnad.',
  'buy.fixedAssetFallback': 'Driftsmiddel',
  'buy.projectForLine': 'Prosjekt for denne linjen',
  'sup.credit.created': 'Leverandørkreditnotaen er bokført.',
  'sup.credit.refunded': 'Refusjonen er bokført.',
  'sup.credit.title': 'Registrer leverandørkreditnota',
  'sup.credit.refundTitle': 'Registrer refusjon av kreditnota',
  'sup.credit.action': 'Bokfør kreditnota',
  'sup.credit.refundAction': 'Registrer refusjon',

});
